// let appWsReviewsTokenView = '{{dados_1}}';
// let appWsReviewsStoreId = '{{dados_3}}';

// if (location.hostname === "localhost") {
//     appWsReviewsTokenView = 'ac4cd211a10b11eed646acbc1a61011f';
//     appWsReviewsStoreId = 'c1de2111b16e6b21b794451fe54ef86f';
// }

// console.log('reviews teste');

// const reviewsCalls = {}

// var ws_reviews_options = {};
// ws_reviews_options.store_reviews = true;
// ws_reviews_options.list_reviews = true;
// ws_reviews_options.product_review = true;
// reviewsEmpty = true
// approvalMode = true


// setTimeout(() => {
//     if (typeof ws_reviews_options_store !== 'undefined') {
//         ws_reviews_options = ws_reviews_options_store;
//     }

//     try{
//         if (localStorage["ws_reviews_options_store"]) {
//             ws_reviews_options = JSON.parse(localStorage["ws_reviews_options_store"]);
//         }
//     }catch(e){}

//     function reviewsApp() {
//         console.log('reviews iniciado');
//         const wsStar = wsMain.tools.createElm({
//             type: 'span',
//             innerHTML: `
//             <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35.44 33.53">
//             <defs>
//             <linearGradient id="half-star-ws-review"><stop offset="50%" class="alt-main"></stop><stop offset="50%" class="alt-last"></stop></linearGradient></defs><path d="M16.5,.71c.39-.68,1.25-.91,1.92-.53,.22,.12,.4,.31,.53,.53l4.81,8.46c.2,.35,.55,.6,.94,.68l9.61,1.92c.75,.14,1.24,.87,1.1,1.62-.05,.25-.17,.49-.34,.68l-6.64,7.15c-.28,.3-.41,.7-.36,1.1l1.13,9.65c.08,.77-.49,1.46-1.26,1.54-.24,.02-.49-.02-.72-.12l-8.92-4.04c-.37-.17-.8-.17-1.17,0l-8.92,4.05c-.71,.31-1.54,0-1.86-.72-.1-.22-.14-.46-.11-.71l1.13-9.65c.05-.4-.08-.8-.36-1.1L.37,14.08c-.52-.56-.49-1.44,.08-1.96,.19-.18,.43-.29,.68-.34l9.61-1.92c.4-.08,.74-.33,.94-.68L16.5,.71Z"/></svg>
//             `
//         });

//         // diferenca de elementos entre dois arrays
//         Array.prototype.diff = function (a) {
//             return this.filter((i) => { return a.indexOf(i) < 0; });
//         };

//         // rendeniza as estrelas e deixa colorido adicionado classes
//         function appendStar(reviewId, rate) {
//             // contador de estrelas, para adicionar no maximo 5 estrelas
//             for (let i = 0; i < 5; i++) {
//                 starClone = wsStar.cloneNode(true)
//                 reviewId.append(starClone)

//                 const star = reviewId.querySelectorAll('span')[i]

//                 // adiciona classes para estrelas que devem ser vazias, preenchidas ou meias
//                 if (i == parseInt(rate) && rate % 1 != 0) star.classList.add('half-star');
//                 else if (i >= rate) star.classList.add('empty-star');
//                 else if (i < rate) star.classList.add('fill-star');
//             };
//         }

//         // linear gradiente pra deixar a meia estrela amarela
//         function creatingLinearGradient() {
//             document.querySelector('body').append(
//                 wsMain.tools.createElm({
//                     type: 'defs',
//                     id: 'half-star-ws-review',
//                     innerHTML: `
//                         <stop offset="50%" class="alt-main"></stop>
//                         <stop offset="50%" class="alt-last"></stop>
//                     `
//                 })
//             )
//         }

//         // ancora dinamica para ver as avaliacoes no rodape
//         function institucionalAnchor() {
//             const institutionalContainer = document.querySelector('footer .institutional-footer')
//             institutionalContainer.append(
//                 wsMain.tools.createElm({
//                     type: 'li',
//                     attrs: {
//                         class: "footer-reviews",
//                     },
//                     innerHTML: '<a href="#nossas-avaliacoes">Avalia&ccedil;&otilde;es</a>',
//                 })
//             )

//             institutionalContainer.querySelector('.footer-reviews').addEventListener('click', () => {
//                 const frame = document.querySelector('.store-reviews')
//                 frame.style.display = 'block'
//                 document.querySelector('body').style.overflow = 'hidden'
//             })
//         }

//         // verifica se existem as ancoras para inserir o bloco de reviews
//         const dynamicAnchor = {
//             bodyAncor() {
//                 const body = document.querySelector('body')
//                 body.classList.add('reviews-start')
//             },
//             productPageAnchor() {
//                 const mainAnchorVrf = document.querySelector('#clients-review')
//                 const secondAnchorVrf = document.querySelector('[data-wsjs-product="star-container-product-description"]')

//                 if (mainAnchorVrf && secondAnchorVrf) return

//                 if (!mainAnchorVrf) {
//                     console.log('teste')
//                     let container = document.querySelector('.prod-side-container')
                    
//                     if (!container) container = document.querySelector('.prod-container .prod-inside-container')
                    
//                     container.append(
//                         wsMain.tools.createElm({
//                             type: 'div',
//                             attrs: {
//                                 id: 'clients-review',
//                                 class: 'clients-review'
//                             }
//                         })
//                     )
//                 }

//                 if (!secondAnchorVrf) {
//                     const referenceElement = document.querySelector(".prod-short-container") ? document.querySelector(".prod-short-container") : document.querySelector('.prod-price-main');
//                     const container = referenceElement.parentNode
//                     const starsAnchor = wsMain.tools.createElm({
//                         type: 'span',
//                         attrs: {
//                             'data-wsjs-product': 'star-container-product-description'
//                         }
//                     })

//                     if (referenceElement.classList.contains('prod-price-main')) {
//                         starsAnchor.classList.add('stars-margin')
//                     }

//                     container.insertBefore(starsAnchor, referenceElement)
//                 }
//             },
//             async homeAnchor(etapa) {
//                 const mainAnchorVrf = document.querySelector('[data-wsjs-sectype="reviews"]')

//                 if(etapa !== "HOME" && !mainAnchorVrf) {
//                     return false
//                 }

//                 if (mainAnchorVrf) return true

//                 const container = document.querySelector('[data-wsjs-draginner]') || document.querySelector('#DivResponse')

//                 if ((window.innerWidth <= 800)) {
//                     console.log('MOBILEEEE')
//                     container.appendChild(
//                         wsMain.tools.createElm({
//                             type: 'section',
//                             innerHTML: `
//                             <div class="container">
//                                 <h2>Avalia&ccedil;&otilde;es da loja</h2>
//                                 <span class="store-review-slider" data-wsjs-slide="slides.perView: 1.5;dots: false; slides.spacing: 10; arrows: false; alignCenter: true;"></span>
//                             </div>
//                             `,
//                             attrs: {
//                                 'data-wsjs-sectype': 'reviews',
//                             }
//                         })
//                     )
//                 } else {
//                     container.appendChild(
//                         wsMain.tools.createElm({
//                             type: 'section',
//                             innerHTML: `
//                             <div class="container">
//                                 <h2>Avalia&ccedil;&otilde;es da loja</h2>
//                                 <span class="store-review-slider" data-wsjs-slide="needOffset: true; slides.min: 4; slides.perView: 4;dots: false; slides.spacing: 30; alignCenter: true;"></span>
//                             </div>
//                             `,
//                             attrs: {
//                                 'data-wsjs-sectype': 'reviews',
//                             }
//                         })
//                     )
//                 }
//                 console.log('ancora do slider')
//                 return true
//             },
//             storeReview() {
//                 const anchorVrf = document.querySelector('.store-reviews')
//                 if (anchorVrf) return

//                 const container = document.querySelector('body')

//                 container.appendChild(
//                     wsMain.tools.createElm({
//                         type: 'div',
//                         innerHTML: `
//                         <div class="store-reviews__close">
//                             <span>
//                             <svg xmlns="http://www.w3.org/2000/svg" width="14.828" height="14.828" viewBox="0 0 14.828 14.828">
//                             <path id="Caminho_8519" data-name="Caminho 8519" d="M978,2308l-12,12m0-12,12,12" transform="translate(-964.586 -2306.586)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
//                             </svg>
//                             </span>
//                         </div>
//                         <iframe src="" frameborder="0"></iframe>
//                         `,
//                         attrs: {
//                             class: 'store-reviews',
//                         }
//                     })
//                 )

//                 console.log('ancora do store review')
//             },
//             prodAnchor() {
//                 const prodAnchor = document.querySelectorAll('.prod-showcase-price-container')

//                 prodAnchor.forEach(elm => {
//                     const container = elm.parentNode

//                     const vrfy = container.querySelector('.ws-review-star-container')

//                     if (vrfy) return

//                     const starsAnchor = wsMain.tools.createElm({
//                         type: 'span',
//                         attrs: {
//                             "data-wsjs-prod-template": "ws-review",
//                             class: 'ws-review-star-container'
//                         }
//                     })

//                     container.insertBefore(starsAnchor, elm)

//                     console.log('ancora no produto ok')
//                 })
//             },
//             iframeUrl() {
//                 console.log('iframeUrl')
//                 const allHashTags = window.location.hash

//                 if (allHashTags.includes('#nossas-avaliacoes')) {
//                     const frame = document.querySelector('.store-reviews')
//                     frame.style.display = 'block'
//                     document.querySelector('body').style.overflow = 'hidden'
//                 }
//             }
//         }

//         // estrelas e reviews da pagina de produto
//         const starRatingProductsPage = {
//             // data atual
//             todayDate() {
//                 const data = new Date()
//                 return `${data.toLocaleDateString("pt-BR").split('/').reverse().join('-')} ${data.toString().split(' ')[4]}`
//             },

//             // botao para proxima pagina
//             nextPage(appWsReviewsTokenView, store, response, filter) {
//                 let page = 2
//                 const allReviews = document.querySelectorAll('[data-wsjs-review-id]')
//                 if (allReviews.length == response.total_reviews) return
//                 if (allReviews.length <= response.total_reviews) {
//                     const reviews = document.querySelector('#clients-review-container')
//                     reviews.append(
//                         wsMain.tools.createElm({
//                             type: 'button',
//                             innerHTML: 'ver mais coment&aacute;rios',
//                             attrs: {
//                                 class: 'button-third'
//                             }
//                         }),
//                         wsMain.tools.createElm({
//                             type: 'div',
//                             innerHTML: '<div class="reviews_loader"></div>',
//                             attrs: {
//                                 class: 'loader_container hideLoader'
//                             }
//                         }),

//                     )

//                     const btnMoreReviews = document.querySelector('#clients-review-container > .button-third')
//                     const loader = document.querySelector('.loader_container')

//                     btnMoreReviews.addEventListener('click', async () => {
//                         const allReviewsActual = document.querySelectorAll('[data-wsjs-review-id]')
//                         // chamada ao endpoint
//                         loader.classList.remove('hideLoader')
//                         btnMoreReviews.style.display = 'none'
//                         const data = await this.getCommentaryData(appWsReviewsTokenView, store, page, filter)
//                         btnMoreReviews.style.display = 'block'
//                         loader.classList.add('hideLoader')
//                         if (allReviewsActual.length == data.total_reviews) {
//                             btnMoreReviews.remove()
//                         }
//                         page++

//                         const fatherContainer = btnMoreReviews.parentNode
//                         fatherContainer.insertBefore(btnMoreReviews, this.createReviews(data))
//                         this.createReportBtn(appWsReviewsTokenView, store)
//                     })
//                 }
//             },

//             // chamada para receber os dados dos reviews
//             async getCommentaryData(appWsReviewsTokenView, store, page = 1, orderBy = '') {
//                 const product = wsMain.globalData.infoProduto.codigo;

//                 let lastCookie = ApiWS.Cookie.get(`reviews_product_sku_${product}`, 'D')

//                 if (lastCookie && page == 1) {
//                     if (orderBy == 'date') return lastCookie

//                     else if (orderBy) {
//                         try {
//                             const url = `https://reviews-ws-script-app.webstore.net.br/product/reviews?store=${store}&product=${product}&tokenView=${appWsReviewsTokenView}&page=${page}&orderBy=${orderBy}&approvalMode=${approvalMode}`;
//                             const response = await fetch(url);
//                             const data = await response.json();
//                             ApiWS.Cookie.set(`reviews_product_sku_${product}`, 'D', data)
//                             return data
//                         } catch (error) {
//                             console.log(error)
//                         }
//                     }
//                     console.log("localStorage funcionando")
//                 }

//                 if (page > 1) {
//                     try {
//                         const url = `https://reviews-ws-script-app.webstore.net.br/product/reviews?store=${store}&product=${product}&tokenView=${appWsReviewsTokenView}&page=${page}&orderBy=${orderBy}&approvalMode=${approvalMode}`;
//                         const response = await fetch(url);
//                         const data = await response.json();

//                         data.reviews !== undefined ? lastCookie.reviews.push(...data.reviews) : ''

//                         ApiWS.Cookie.set(`reviews_product_sku_${product}`, 'D', lastCookie)

//                         return lastCookie
//                     } catch (error) {
//                         console.log(error)
//                     }
//                 }

//                 try {
//                     const url = `https://reviews-ws-script-app.webstore.net.br/product/reviews?store=${store}&product=${product}&tokenView=${appWsReviewsTokenView}&page=${page}&orderBy=${orderBy}&approvalMode=${approvalMode}`;
//                     const response = await fetch(url);
//                     const data = await response.json();
//                     ApiWS.Cookie.set(`reviews_product_sku_${product}`, 'D', data)
//                     reviewsCalls.pagProdFetch = true
//                     return data
//                 } catch (error) {
//                     console.log(error)
//                 }
//             },

//             // verifica se o usuario esta logado
//             async vrfyUser(appWsReviewsTokenView, store, elm, like) {
//                 const user = document.querySelector('#HD_LVCLI_NOME').value

//                 // apenas deixa o usuario fazer o fetch se estiver logado
//                 if (user != 'Visitante') {
//                     // like e deslike
//                     const dataAtual = this.todayDate()
//                     const nome = document.querySelector('#HD_LVCLI_NOME').value
//                     const email = document.querySelector('#HD_LVCLI_EMAIL').value
//                     document.querySelectorAll(elm).forEach(thumbs => {
//                         thumbs.setAttribute('onclick', '')

//                         thumbs.addEventListener('click', async (e) => {
//                             const reviewId = e.target.parentNode.getAttribute('data-wsjs-likes-review-id')
//                             let response
//                             try {
//                                 response = await fetch(`https://reviews-ws-script-app.webstore.net.br/store/reviews/like?store=${store}&review=${reviewId}&tokenView=${appWsReviewsTokenView}`, {
//                                     method: 'post',
//                                     headers: {
//                                         'Content-Type': 'application/json'
//                                     },
//                                     body: JSON.stringify({
//                                         "name": nome,
//                                         "email": email,
//                                         "date": dataAtual,
//                                         "type": like
//                                     })
//                                 })
//                             } catch (error) {
//                                 console.log(error)
//                             }

//                             if (!response.ok) {
//                                 throw new Error(`${response.status}: ${await response.text()}`)
//                             }

//                             await response.json()
//                             thumbs.classList.toggle('liked')
//                         })
//                     })
//                 }
//             },

//             // cria botao de denuncia
//             createReportBtn(appWsReviewsTokenView, store) {
//                 const allReviews = document.querySelectorAll('[data-wsjs-review-id] > .last-half')
//                 const tresPontos = `<svg id="Camada_2" data-name="Camada 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.17 65.87">
//                 <defs>
//                 <style>
//                 .cls-1 {
//                 fill: #393939;
//                 }
//                 </style>
//                 </defs>
//                 <g id="Camada_1-2" data-name="Camada 1">
//                 <g id="Grupo_3030" data-name="Grupo 3030">
//                 <circle id="Elipse_13" data-name="Elipse 13" class="cls-1" cx="6.59" cy="6.59" r="6.59"/>
//                 <circle id="Elipse_14" data-name="Elipse 14" class="cls-1" cx="6.59" cy="32.94" r="6.59"/>
//                 <circle id="Elipse_15" data-name="Elipse 15" class="cls-1" cx="6.59" cy="59.28" r="6.59"/>
//                 </g>
//                 </g>
//                 </svg>
//                 `
//                 allReviews.forEach(review => {
//                     if (!(review.querySelector('.report-options'))) {
//                         review.append(
//                             wsMain.tools.createElm({
//                                 type: 'div',
//                                 attrs: {
//                                     class: 'report-options'
//                                 }
//                             }),
//                         )
//                     }
//                 })

//                 const reportOptions = document.querySelectorAll('[data-wsjs-review-id] > .last-half > .report-options')

//                 reportOptions.forEach(elm => {
//                     if (!(elm.querySelector('.report-icon') && elm.querySelector('.report-btn'))) {
//                         elm.append(
//                             wsMain.tools.createElm({
//                                 type: 'span',
//                                 innerHTML: `${tresPontos}`,
//                                 attrs: {
//                                     class: 'report-icon'
//                                 }
//                             }),
//                             wsMain.tools.createElm({
//                                 type: 'ul',
//                                 attrs: {
//                                     class: 'report-btn'
//                                 }
//                             })
//                         )
//                     }
//                 })

//                 document.querySelectorAll('.report-btn').forEach(div => {
//                     div.append(
//                         wsMain.tools.createElm({
//                             type: 'li',
//                             innerHTML: `Denunciar coment&aacute;rio`,
//                             attrs: {
//                                 'report-options': 'report-comentary'
//                             }
//                         })
//                     )
//                 })

//                 const liReportOption = document.querySelectorAll('[report-options="report-comentary"]')
//                 liReportOption.forEach(li => {
//                     li.append(
//                         wsMain.tools.createElm({
//                             type: 'div',
//                             attrs: {
//                                 class: 'report-combobox-btn'
//                             }
//                         })
//                     )

//                     li.addEventListener('click', () => {
//                         li.childNodes[1].classList.add('report-option-btn-active')
//                     })
//                 })

//                 document.querySelectorAll('.report-combobox-btn').forEach(div => {
//                     div.append(
//                         wsMain.tools.createElm({
//                             type: 'select',
//                             innerHTML: `<option value="0">Selecione o motivo</option>`,
//                             attrs: {
//                                 class: 'report-combobox'
//                             }
//                         }),
//                         wsMain.tools.createElm({
//                             type: 'div',
//                             attrs: {
//                                 class: 'send-report'
//                             }
//                         })
//                     )
//                 })

//                 const reportOption = document.querySelectorAll('.report-icon')
//                 reportOption.forEach(icon => {
//                     icon.addEventListener('click', () => {
//                         icon.nextElementSibling.classList.toggle('active-report-btn')
//                         icon.nextElementSibling.childNodes[0].childNodes[1].classList.remove('report-option-btn-active')
//                     })

//                     document.addEventListener('click', (e) => {
//                         if (!icon.contains(e.target) && !icon.nextElementSibling.contains(e.target)) {
//                             icon.nextElementSibling.classList.remove('active-report-btn')
//                             icon.nextElementSibling.childNodes[0].childNodes[1].classList.remove('report-option-btn-active')

//                         }
//                     });
//                 })


//                 // verifica se o usuario esta logado ou nao
//                 let user = document.querySelector('#HD_LVCLI_NOME').value
//                 let email = document.querySelector('#HD_LVCLI_EMAIL').value

//                 const loginMsg = document.querySelectorAll('.send-report')

//                 if (user != 'Visitante') {
//                     document.querySelectorAll('.send-report').forEach(btn => {
//                         btn.classList.add('logged-user')
//                     })

//                     loginMsg.forEach(msg => {
//                         if (!(msg.querySelector('.report-to-send'))) {
//                             msg.append(
//                                 wsMain.tools.createElm({
//                                     type: 'span',
//                                     innerHTML: 'enviar',
//                                     attrs: {
//                                         class: 'report-to-send',
//                                     }
//                                 })
//                             )
//                         }
//                     })

//                     // opcoes de denuncias do combobox
//                     document.querySelectorAll('.report-combobox').forEach(elm => {
//                         elm.append(
//                             wsMain.tools.createElm({
//                                 type: 'option',
//                                 innerHTML: 'Spam',
//                                 attrs: {
//                                     value: 'spam'
//                                 }
//                             }),
//                             wsMain.tools.createElm({
//                                 type: 'option',
//                                 innerHTML: 'Atividades improprias',
//                                 attrs: {
//                                     value: 'atividades-improprias'
//                                 }
//                             }),
//                             wsMain.tools.createElm({
//                                 type: 'option',
//                                 innerHTML: 'Símbolos ou discurso de &oacute;dio',
//                                 attrs: {
//                                     value: 'simbolos-ou-discurso-de-odio'
//                                 }
//                             }),
//                             wsMain.tools.createElm({
//                                 type: 'option',
//                                 innerHTML: 'Violência ou organiza&ccedil;&otilde;es perigosas',
//                                 attrs: {
//                                     value: 'Violencia-ou-organizacoes-perigosas'
//                                 }
//                             }),
//                             wsMain.tools.createElm({
//                                 type: 'option',
//                                 innerHTML: 'Bullying ou ass&eacute;dio',
//                                 attrs: {
//                                     value: 'Bullying-ou-assedio'
//                                 }
//                             }),
//                             wsMain.tools.createElm({
//                                 type: 'option',
//                                 innerHTML: 'Viola&ccedil;&otilde;es de propriedade intelectual',
//                                 attrs: {
//                                     value: 'violacoes-de-propriedade-intelectual'
//                                 }
//                             }),
//                             wsMain.tools.createElm({
//                                 type: 'option',
//                                 innerHTML: 'Golpes ou fraude',
//                                 attrs: {
//                                     value: 'golpes-ou-fraude'
//                                 }
//                             }),
//                             wsMain.tools.createElm({
//                                 type: 'option',
//                                 innerHTML: 'Informa&ccedil;&atilde;o falsa',
//                                 attrs: {
//                                     value: 'informacoes-falsa'
//                                 }
//                             }),
//                             wsMain.tools.createElm({
//                                 type: 'option',
//                                 innerHTML: 'outros',
//                                 attrs: {
//                                     value: 'outros'
//                                 }
//                             }),
//                         )
//                     })

//                     // envia os dados para o fetch
//                     loginMsg.forEach(btn => {
//                         btn.addEventListener('click', async (e) => {
//                             const reviewId = e.target.closest('[data-wsjs-review-id]').getAttribute('data-wsjs-review-id')
//                             const comboBox = e.target.parentNode.previousSibling
//                             const reportReason = comboBox.options[comboBox.selectedIndex].text

//                             // chamada ao endpoint
//                             let response;
//                             try {
//                                 response = await fetch(`https://reviews-ws-script-app.webstore.net.br/store/reviews/alert?store=${store}&review=${reviewId}&tokenView=${appWsReviewsTokenView}`, {
//                                     method: 'post',
//                                     headers: {
//                                         'Content-Type': 'application/json'
//                                     },
//                                     body: JSON.stringify({
//                                         "comment": reportReason,
//                                         "name": user,
//                                         "email": email,
//                                         "date": this.todayDate(),
//                                         "reviewId": reviewId
//                                     })
//                                 })

//                             } catch (error) {
//                                 console.log(error)
//                             }

//                             if (!response.ok) {
//                                 throw new Error(`${response.status}: ${await response.text()}`)
//                             }

//                             const data = await response.json()
//                         })
//                     })

//                 } else {
//                     loginMsg.forEach(msg => {
//                         msg.remove()
//                     })

//                     liReportOption.forEach(li => {
//                         li.setAttribute('onclick', `window.location.href='/login'`)
//                     })

//                 }
//             },

//             // calculo para porcentagem da barra de progresso
//             totalRatesCalculator(data) {
//                 let obj = data.rates_total;
//                 if (!obj) return {};
//                 const totalOfRates = Object.keys(obj).reduce((r, k) => r + obj[k], 0);

//                 let objToReturn = {};
//                 Object.keys(obj).forEach(k => objToReturn[k] = ((obj[k] * 100) / totalOfRates).toFixed(2));

//                 return objToReturn;
//             },

//             // estrelas da descricao do produto
//             async starsInProdDescription(data) {
//                 console.log("test ~ starsInProdDescription ~ data:", data)
//                 const starContainer = document.querySelector('[data-wsjs-product="star-container-product-description"]')
//                 starContainer.append(
//                     wsMain.tools.createElm({
//                         type: 'a',
//                         attrs: {
//                             title: 'avalições do produto',
//                             id: 'link-to-reviews',
//                             href: '#clients-average-container'
//                         }
//                     })
//                 )

//                 document.querySelector('#link-to-reviews').append(
//                     wsMain.tools.createElm({
//                         type: 'span',
//                         attrs: {
//                             id: 'stars-in-prod-desc'
//                         }
//                     }),
//                     wsMain.tools.createElm({
//                         type: 'p',
//                         attrs: {
//                             id: 'stars-in-prod-desc-qnty'
//                         }
//                     })
//                 )
                
//                 starContainer.querySelector('#stars-in-prod-desc-qnty').innerHTML = `(${data.total_reviews})`
//                 appendStar(starContainer.querySelector('#stars-in-prod-desc'), data.rate_avarege);
//             },

//             progressBarStructure() {
//                 // estrutura de containers
//                 const clientAverageContainer = document.querySelector('#clients-average-container')

//                 clientAverageContainer.append(
//                     wsMain.tools.createElm({
//                         type: 'div',
//                         attrs: {
//                             id: "clients-average-container-data"
//                         }
//                     }),
//                     wsMain.tools.createElm({
//                         type: 'div',
//                         attrs: {
//                             id: "clients-average-graphic"
//                         }
//                     }),
//                 )

//                 // barra de progresso das reviews
//                 const clientAverageGraphic = document.querySelector('#clients-average-graphic')
//                 clientAverageGraphic.append(
//                     wsMain.tools.createElm({
//                         type: 'div',
//                         attrs: {
//                             id: 'all-stars-progress-bar'
//                         }
//                     }),
//                     wsMain.tools.createElm({
//                         type: 'div',
//                         attrs: {
//                             id: 'all-progress-bar'
//                         }
//                     }),
//                     wsMain.tools.createElm({
//                         type: 'div',
//                         attrs: {
//                             id: 'all-avaliations-progress-bar'
//                         }
//                     })
//                 )

//                 for (let i = 5; i > 0; i--) {
//                     document.querySelector('#all-stars-progress-bar').append(
//                         wsMain.tools.createElm({
//                             type: 'span',
//                             innerHTML: `${i == 1 ? i + ' estrela' : i + ' estrelas'}`
//                         })
//                     )
//                     document.querySelector('#all-progress-bar').append(
//                         wsMain.tools.createElm({
//                             type: 'div',
//                             innerHTML: `<div class="progress-bar" rating-id="r${i}"></div>`,
//                             attrs: {
//                                 class: "progress",
//                                 "star-number": i
//                             }
//                         })
//                     )
//                     document.querySelector('#all-avaliations-progress-bar').append(
//                         wsMain.tools.createElm({
//                             type: 'span',
//                             innerHTML: `r${i}`,
//                             attrs: {
//                                 "ratings": `r${i}`
//                             }
//                         })
//                     )
//                 }
//             },

//             clientsAvarageStructure(rateAvarage, totalReviews) {
//                 const clientAverageDataContainer = document.querySelector('#clients-average-container-data')

//                 clientAverageDataContainer.append(
//                     wsMain.tools.createElm({
//                         type: 'div',
//                         attrs: {
//                             id: 'client-average-data'
//                         }
//                     }),
//                 )

//                 const clientAverageData = document.querySelector('#client-average-data')
                
//                 totalReviews = totalReviews == 1 ? `${totalReviews} avalia&ccedil;&atilde;o` : `${totalReviews} avalia&ccedil;&otilde;es`                

//                 clientAverageData.append(
//                     wsMain.tools.createElm({
//                         type: 'p',
//                         attrs: {
//                             class: 'nota'
//                         },
//                         innerHTML: `${rateAvarage}`,
//                     }),
//                 )

//                 clientAverageData.append(
//                     wsMain.tools.createElm({
//                         type: 'div',
//                         attrs: {
//                             id: 'average-all-stars'
//                         }
//                     })
//                 )

//                 clientAverageData.append(
//                     wsMain.tools.createElm({
//                         type: 'p',
//                         innerHTML: `total de ${totalReviews}`,
//                     }),
//                 )
//             },

//             // media dos users
//             async createClientAvarege(response) {
//                 this.progressBarStructure()

//                 const percentageOfRates = this.totalRatesCalculator(response)

//                 const ratingIds = document.querySelectorAll('#all-progress-bar > .progress > [rating-id]')
//                 for (let i = 1; i <= ratingIds.length; i++) {
//                     document.querySelector(`[rating-id=r${i}]`).setAttribute('style', `--percentage: ${percentageOfRates[`r${i}`]}%`)
//                 }

//                 document.querySelectorAll('#all-avaliations-progress-bar > span').forEach(rating => {
//                     const rate = rating.getAttribute('ratings')
//                     rating.innerHTML = response.rates_total[rate]
//                 })

//                 this.clientsAvarageStructure(response.rate_avarege, response.total_reviews)
//                 const clientAverageData = document.querySelector('#client-average-data')
//                 appendStar(clientAverageData.querySelector('#average-all-stars'), response.rate_avarege)
//             },

//             // filtros
//             async clientsReviewFilter(appWsReviewsTokenView, store) {
//                 const filterContainer = document.querySelector('#clients-review-filter')

//                 filterContainer.append(
//                     wsMain.tools.createElm({
//                         type: 'div',
//                         innerHTML: '<span>Ordenar por:</span>',
//                         attrs: {
//                             class: 'filter-title'
//                         }
//                     }),
//                     wsMain.tools.createElm({
//                         type: 'select',
//                         attrs: {
//                             class: 'reviews-filters-container'
//                         }
//                     })
//                 )

//                 document.querySelector('.reviews-filters-container').append(
//                     wsMain.tools.createElm({
//                         type: 'option',
//                         innerHTML: 'Mais recentes',
//                         attrs: {
//                             class: 'reviews-filters-options',
//                             'value': 'date'
//                         }
//                     }),
//                     wsMain.tools.createElm({
//                         type: 'option',
//                         innerHTML: 'Mais baixa',
//                         attrs: {
//                             class: 'reviews-filters-options',
//                             'value': 'rateL'
//                         }
//                     }),
//                     wsMain.tools.createElm({
//                         type: 'option',
//                         innerHTML: 'Mais alta',
//                         attrs: {
//                             class: 'reviews-filters-options',
//                             'value': 'rateH'
//                         }
//                     }),
//                 )

//                 // faz a nova chamada com o filtro
//                 document.querySelector('.reviews-filters-container').addEventListener('change', async (e) => {
//                     const filter = e.target.value
//                     const appReview = document.querySelector('#clients-review-container')
                    
//                     appReview.innerHTML = ''
//                     appReview.append(
//                         wsMain.tools.createElm({
//                             type: 'div',
//                             attrs: {
//                                 class: 'loader-container'
//                             }
//                         })
//                         )
                        
//                     appReview.querySelector('.loader-container').append(
//                         wsMain.tools.createElm({
//                             type: 'div',
//                             attrs: {
//                                 class: 'loader'
//                             }
//                         })
//                     )
                        
//                     const data = await this.getCommentaryData(appWsReviewsTokenView, store, 1, filter)
//                     appReview.querySelector('.loader-container').remove()
//                     this.createReviews(data)
//                     this.nextPage(appWsReviewsTokenView, store, data, filter)
//                     this.createReportBtn(appWsReviewsTokenView, store)
//                 })
//             },

//             // cria as reviews
//             createReviews(response) {
//                 const likes = `<svg id="Camada_2" data-name="Camada 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 106.43 103.61">
//                 <defs>
//                   <style>
//                     .cls-1 {
//                       fill: #393939;
//                     }
//                   </style>
//                 </defs>
//                 <g id="Camada_1-2" data-name="Camada 1">
//                   <g id="Grupo_3673" data-name="Grupo 3673">
//                     <path id="Caminho_4671" data-name="Caminho 4671" class="cls-1" d="M75.15,103.6h-19.49c-4.52,.08-8.92-1.41-12.46-4.21l-15.54-12,4.72-6.1,15.9,12.31c2.16,1.53,4.74,2.32,7.39,2.26h19.49c4.82-.16,9.05-3.28,10.62-7.85l12.41-37.7c.85-1.88,.69-4.05-.41-5.79-1.37-1.71-3.49-2.65-5.69-2.52h-20.51c-2.61,.01-5.1-1.11-6.82-3.08-1.77-2.04-2.54-4.77-2.11-7.44l2.56-16.47c.5-3.03-1.23-5.98-4.1-7.03-2.49-.75-5.19,.06-6.87,2.05l-21.03,31.28-6.36-4.25L47.87,5.8c4.47-6.24,13.15-7.67,19.38-3.2,4.41,3.16,6.57,8.6,5.55,13.92l-2.51,16.16c-.09,.45,.02,.92,.31,1.28,.27,.27,.64,.42,1.02,.41h20.52c4.68-.16,9.15,1.98,11.95,5.74,2.55,3.75,3.07,8.52,1.39,12.74l-12.26,37.34c-2.47,7.92-9.77,13.33-18.06,13.42Z"/>
//                     <path id="Caminho_4672" data-name="Caminho 4672" class="cls-1" d="M19.24,97.96h-5.13c-9.49,0-14.11-4.46-14.11-13.59V34.11c0-9.13,4.62-13.59,14.11-13.59h5.13c9.49,0,14.1,4.46,14.1,13.59v50.26c0,9.13-4.6,13.59-14.1,13.59ZM14.11,28.21c-5.59,0-6.41,1.33-6.41,5.9v50.26c0,4.57,.82,5.89,6.41,5.89h5.13c5.59,0,6.41-1.33,6.41-5.89V34.11c0-4.57-.82-5.9-6.41-5.9h-5.13Z"/>
//                   </g>
//                 </g>
//                 </svg>`

//                 const reviewContainer = document.querySelector('#clients-review-container')
//                 response.reviews.forEach((review, i) => {
//                     reviewContainer.append(
//                         wsMain.tools.createElm({
//                             type: 'div',
//                             innerHTML: `
//                             <div class="first-half">
//                             </div>
//                             <div class="last-half">
//                             <div class='comentary-and-likes'>
//                             </div>
//                             </div>
//                             `,
//                             attrs: {
//                                 'data-wsjs-review-id': review.id,
//                             }
//                         })
//                     )

//                     // tratamento da data do review
//                     let reviewDate = new Date(review.date).toLocaleString().split(',')
//                     reviewDate = reviewDate[0]

//                     const reviewDiv = document.querySelector(`[data-wsjs-review-id="${review.id}"]`)

//                     if (document.querySelectorAll(`[data-wsjs-review-id="${review.id}"]`).length == 1) {
//                         if (!(reviewDiv.querySelector('.stars'))) {
//                             const customerArr = review.customer.split(' ')
//                             const customer = [customerArr[0], `${customerArr[1][0]}.`]
//                             reviewDiv.querySelector(':scope > .first-half')
//                                 .append(
//                                     wsMain.tools.createElm({
//                                         type: 'div',
//                                         attrs: {
//                                             class: 'stars'
//                                         }
//                                     }),
//                                     wsMain.tools.createElm({
//                                         type: 'div',
//                                         attrs: {
//                                             class: 'customer-infos'
//                                         }
//                                     })
//                                 )

//                             reviewDiv.querySelector(':scope > .first-half .customer-infos')
//                                 .append(
//                                     wsMain.tools.createElm({
//                                         type: 'span',
//                                         innerHTML: customer.join(' '),
//                                         attrs: {
//                                             class: 'customer-infos__name'
//                                         }
//                                     }),
//                                     wsMain.tools.createElm({
//                                         type: 'span',
//                                         innerHTML: `Avaliada em ${reviewDate}`,
//                                         attrs: {
//                                             class: 'customer-infos__date'
//                                         }
//                                     })
//                                 )

//                             reviewDiv.querySelector('.comentary-and-likes')
//                                 .append(
//                                     wsMain.tools.createElm({
//                                         type: 'p',
//                                         innerHTML: `${review.comment == 'N/A' ? '' : review.comment}`
//                                     }),
//                                     wsMain.tools.createElm({
//                                         type: 'div',
//                                         attrs: {
//                                             class: 'likes-container'
//                                         }
//                                     }),
//                                 )

//                             document.querySelector(`[data-wsjs-review-id="${review.id}"] > .last-half > .comentary-and-likes > .likes-container`).append(
//                                 wsMain.tools.createElm({
//                                     type: 'span',
//                                     innerHTML: `Esta informa&ccedil;&atilde;o foi &uacute;til?`,
//                                     attrs: {
//                                         class: 'likes',
//                                     }
//                                 }),
//                                 wsMain.tools.createElm({
//                                     type: 'span',
//                                     innerHTML: `${likes} Sim <span>(${review.likes})</span>`,
//                                     attrs: {
//                                         class: 'likes',
//                                         'data-wsjs-likes-review-id': `${review.id}`,
//                                         onclick: `window.location.href='/login'`
//                                     }
//                                 }),
//                                 wsMain.tools.createElm({
//                                     type: 'span',
//                                     innerHTML: `${likes} N&atilde;o <span>(${review.deslikes})</span>`,
//                                     attrs: {
//                                         class: 'deslikes',
//                                         'data-wsjs-likes-review-id': `${review.id}`,
//                                         onclick: `window.location.href='/login'`
//                                     }
//                                 })
//                             )
//                         }
//                         appendStar(reviewDiv.querySelector('.stars'), review.rate)
//                     }
//                 })

//                 // verifica se há duplicatas e remove
//                 response.reviews.forEach((review, i) => {
//                     let dupReview = document.querySelectorAll(`[data-wsjs-review-id="${review.id}"]`)

//                     if (dupReview.length > 1) {
//                         for (let i = 1; i < dupReview.length; i++) {
//                             dupReview[i].remove()
//                         }
//                     }
//                 })
//             },

//             // chama as outras funcoes desse objeto
//             async createContainersAndCallFunctions(appWsReviewsTokenView, store) {
//                 const appReview = document.querySelector('.clients-review')
//                 const data = await this.getCommentaryData(appWsReviewsTokenView, store, 1, "date")

//                 if (typeof reviewsEmpty !== "undefined" && data.total_reviews == 0 || !data.total_reviews) {
//                     document.querySelector('#clients-review').remove()
//                     document.querySelector('[data-wsjs-product="star-container-product-description"]').remove()
//                     return
//                 }

//                 // containers na ancora principal
//                 appReview.append(
//                     wsMain.tools.createElm({
//                         type: 'h2',
//                         innerHTML: 'Avalia&ccedil;&otilde;es dos clientes'
//                     }),
//                     wsMain.tools.createElm({
//                         type: 'div',
//                         attrs: {
//                             id: 'clients-average-container',
//                         }
//                     }),
//                     wsMain.tools.createElm({
//                         type: 'div',
//                         attrs: {
//                             id: 'clients-review-filter',
//                         }
//                     }),
//                     wsMain.tools.createElm({
//                         type: 'div',
//                         attrs: {
//                             id: 'clients-review-container',
//                         }
//                     })
//                 )

//                 if (isNaN(data.rate_avarege)) data.rate_avarege = 0;

//                 // funcoes
//                 this.createClientAvarege(data)
//                 this.starsInProdDescription(data)
//                 this.createReviews(data)

//                 this.createReportBtn(appWsReviewsTokenView, store)
//                 this.vrfyUser(appWsReviewsTokenView, store, '.likes', "like")
//                 this.vrfyUser(appWsReviewsTokenView, store, '.deslikes', "deslike")
//                 this.clientsReviewFilter(appWsReviewsTokenView, store)
//                 this.nextPage(appWsReviewsTokenView, store, data)
//             }
//         }

//         // estrelas da pagina home e relacionados
//         const starRatingHome = {
//             // funcao para receber dados das estrelas (rating)
//             async getData(appWsReviewsTokenView, store) {
//                 const wsProds = wsMain.globalData.listHomeProds?.produtos;
//                 const wsGrupos = wsMain.globalData.listGroupProds?.grupos;
//                 const wsList = wsMain.globalData.listCategoryProds?.produtos;
//                 const wsRelatedProds = wsMain.globalData.listRelatedProds != null ? wsMain.globalData.listRelatedProds : null;

//                 // tratativa dos SKU dos produtos
//                 let prodTotal = []
//                 if (wsProds) wsProds.forEach(p => prodTotal.push(p.codigo));
//                 if (wsGrupos) wsGrupos.forEach(g => g.produtos.forEach(p => prodTotal.push(p.codigo)));
//                 if (wsList) wsList.forEach(p => prodTotal.push(p.codigo));
//                 if (wsRelatedProds) wsRelatedProds.forEach(p => prodTotal.push(p.codigo));

//                 // todos SKU dos produtos sem repeticao para realizar o fetch
//                 const treatedProds = [...new Set(prodTotal)];

//                 // cache
//                 let lastCookie = ApiWS.Cookie.get('reviews_products_home', 'D')
//                 if (lastCookie) {
//                     const arrCookieSku = lastCookie.map(obj => {
//                         return obj.sku
//                     })

//                     if (arrCookieSku.sort().join('') == treatedProds.sort().join('')) {
//                         return lastCookie
//                     } else {
//                         const diference = treatedProds.diff(arrCookieSku)
//                         const url = `https://reviews-ws-script-app.webstore.net.br/product/rate?store=${store}&tokenView=${appWsReviewsTokenView}&products=${diference}&approvalMode=${approvalMode}`;
//                         let data
//                         try {
//                             const response = await fetch(url);
//                             data = await response.json();
//                         } catch (error) {
//                             console.log(error)
//                         }

//                         lastCookie.push(...data)
//                         ApiWS.Cookie.set('reviews_products_home', 'D', lastCookie);
//                         return lastCookie
//                     }
//                 }

//                 // dados retornados do fetch (sku + rate)

//                 try {
//                     const url = `https://reviews-ws-script-app.webstore.net.br/product/rate?store=${store}&tokenView=${appWsReviewsTokenView}&products=${treatedProds}&approvalMode=${approvalMode}`;
//                     const response = await fetch(url);
//                     const data = await response.json();
//                     ApiWS.Cookie.set('reviews_products_home', 'D', data);
//                     reviewsCalls.homeProdListFetch = true
//                     return data
//                 } catch (err) {
//                     console.log(err)
//                     return []
//                 }
//             },

//             // funcao para criar as estrelas dinamicamente da listagem
//             starRatingHome(sku, rate, total) {
//                 if (typeof reviewsEmpty !== "undefined" && rate == 0) return
//                 let prodsInPage = document.querySelectorAll(`[ws-prod-sku="${sku}"]`);

//                 let starClone
//                 prodsInPage.forEach(prod => {
//                     // contador de estrelas, para adicionar no maximo 5 estrelas
//                     for (let i = 0; i < 5; i++) {
//                         starClone = wsStar.cloneNode(true)
//                         prod.querySelector('.ws-review-star-container').append(starClone)
//                         const star = prod.querySelectorAll('.ws-review-star-container > span')[i]

//                         // adiciona classes para estrelas que devem ser vazias, preenchidas ou meias
//                         if (i == parseInt(rate) && rate % 1 != 0) star.classList.add('half-star');
//                         else if (i >= rate) star.classList.add('empty-star');
//                         else if (i < rate) star.classList.add('fill-star');
//                     };

//                     prod.querySelector('.ws-review-star-container').append(
//                         wsMain.tools.createElm({
//                             type: 'p',
//                             innerHTML: `(${total})`,
//                             attrs: {
//                                 class: 'allreviews'
//                             }
//                         }),
//                     )
//                 })
//             },

//             // pega os dados e cria estrelas
//             async getDataAndCreateStars(appWsReviewsTokenView, store) {
//                 const response = await this.getData(appWsReviewsTokenView, store);
//                 if (response.length == 0) return

//                 // ativa a funcao de gerar estrelas e uma animacao das estrelas para cada produto
//                 response.forEach((elm, i) => {
//                     // console.log("test ~ response.forEach ~ elm:", elm.rate)
//                     this.starRatingHome(elm.sku, elm.rate, elm.totalReviews)

//                     if (i == response.length - 1) {
//                         setTimeout(() => {
//                             document.querySelectorAll('.ws-review-star-container').forEach(elm => elm.removeAttribute('data-wsjs-prod-template'));
//                         }, 1000);
//                     }
//                 });
//             }
//         }

//         const shopReviews = {
//             startIframe(appWsReviewsTokenView, store) {
//                 console.log('startIframe')
//                 const frame = document.querySelector('.store-reviews > iframe')
//                 frame.src = `https://reviews-ws-script-app.webstore.net.br/store/reviewstore?tokenView=${appWsReviewsTokenView}&store=${store}`

//                 this.closeFrame()
//             },
//             closeFrame() {
//                 const frame = document.querySelector('.store-reviews')
//                 const frameBtn = document.querySelector('.store-reviews > .store-reviews__close')

//                 frameBtn.addEventListener('click', () => {
//                     frame.style.display = 'none'
//                     document.querySelector('body').style.overflow = 'initial'
//                     history.replaceState(null, null, ' ');
//                 })
//             },
//             openFrame() {
//                 document.querySelectorAll('[shop-review]').forEach(review => {
//                     review.addEventListener('click', () => {
//                         document.querySelector('body').style.overflow = 'hidden'
//                         const frame = document.querySelector('.store-reviews')
//                         frame.style.display = 'block'
//                     })
//                 })
//             }
//         }

//         // slider de comentarios na pagina home
//         const homeReviewSlider = {
//             // responsavel por realizar a chamada e obter os dados do endpoint
//             async getData(appWsReviewsTokenView, store, limit, orderby) {
//                 let lastCookie = ApiWS.Cookie.get(`home_slider`, 'D')

//                 if (lastCookie) return lastCookie

//                 try {
//                     let url = `https://reviews-ws-script-app.webstore.net.br/store/reviews?store=${store}&tokenView=${appWsReviewsTokenView}&fiveStars=true&approvalMode=${approvalMode}`
//                     if(limit) url+= `&limit=${limit}`
//                     if(orderby) url+= `&orderby=${orderby}`
//                     const response = await fetch(url)

//                     const data = await response.json()

//                     ApiWS.Cookie.set(`home_slider`, 'D', data)
//                     reviewsCalls.homeSliderFetch = true
//                     return data

//                 } catch (error) {
//                     console.log(error)
//                     return { reviews: [] }
//                 }
//             },

//             async createReviewSlider(appWsReviewsTokenView, store, etapa) {
//                 const ancor = await dynamicAnchor.homeAnchor(etapa)
//                 if(!ancor) return

//                 const limit = 10
//                 const orderby = 'date'
//                 const data = await this.getData(appWsReviewsTokenView, store, limit, orderby)

//                 if (!data.reviews || data.reviews.length == 0) {
//                     const storeReviewsSections = document.querySelector('[data-wsjs-sectype="reviews"]')
//                     storeReviewsSections.style.display = 'none'
//                     return
//                 }

//                 const reviewsTreated = data.reviews
//                 const sliderContainer = wsMain.tools.createElm('div')

//                 reviewsTreated.forEach((review, i) => {
//                     let index = review.id
//                     let date = review.date.split(' ')[0].split('-')
//                     if (!Array.isArray(date) || date.length < 2) date = review.date.split('/').reverse()

//                     const customerArr = review.customer.toLowerCase().trim().split(' ')
//                     let customer = customerArr[0] + ' ' + customerArr[1][0] + '.'
//                     if (typeof customer == 'undefined') customer = customerArr[0]

//                     sliderContainer.append(
//                         wsMain.tools.createElm({
//                             type: 'div',
//                             attrs: {
//                                 'shop-review': index,
//                             }
//                         })
//                     )
//                     sliderContainer.querySelector(`[shop-review="${index}"]`).append(
//                         wsMain.tools.createElm({
//                             type: 'a',
//                             attrs: {
//                                 title: 'comentarios da loja',
//                                 class: 'iframe-redirect',
//                                 href: '#nossas-avaliacoes'
//                             }
//                         }),
//                         wsMain.tools.createElm({
//                             type: 'div',
//                             attrs: {
//                                 class: 'lower-half-infos'
//                             }
//                         })
//                     )

//                     if (review.comment !== "N/A" && review.comment.trim() !== '') {
//                         sliderContainer.querySelector(`[shop-review="${index}"] > .lower-half-infos`).append(
//                             wsMain.tools.createElm({
//                                 type: 'p',
//                                 innerHTML: `"${review.comment}"`,
//                                 attrs: {
//                                     class: 'review-commentary'
//                                 }
//                             })
//                         )
//                     }

//                     sliderContainer.querySelector(`[shop-review="${index}"] > .lower-half-infos`).append(
//                         wsMain.tools.createElm({
//                             type: 'p',
//                             innerHTML: customer,
//                             attrs: {
//                                 class: 'customer-name'
//                             }
//                         }),
//                         wsMain.tools.createElm({
//                             type: 'p',
//                             innerHTML: `Avaliada em ${date[2]}/${date[1]}/${date[0]}`,
//                             attrs: {
//                                 class: 'shop-review__date'
//                             }
//                         }),
//                         wsMain.tools.createElm({
//                             type: 'div',
//                             attrs: {
//                                 class: 'review-stars'
//                             }
//                         }),
//                     )

//                     appendStar(sliderContainer.querySelector(`[shop-review="${index}"] > .lower-half-infos > .review-stars`), review.rate)
//                 })


//                 const options = wsMain.tools.getWsData(document.querySelector('.store-review-slider'), 'slide')

//                 let [sliderVrf, slider] = wsMain.tools.createSlide(sliderContainer, options)

//                 wsMain.tools.replaceSpanTag(sliderContainer, document.querySelector('[data-wsjs-sectype="reviews"] .store-review-slider'))

//                 if (reviewsTreated.length <= 4) {
//                     document.querySelector('.store-review-slider').classList.add('no-slider')
//                 } else if (sliderVrf) slider.update();


//                 shopReviews.openFrame()
//             }
//         }

//         // reputacao da loja nas paginas institucionais
//         const shopPrestige = {
//             async getPrestigeData(appWsReviewsTokenView, store) {
//                 try {
//                     const url = `https://reviews-ws-script-app.webstore.net.br/store/reviews?store=${store}&tokenView=${appWsReviewsTokenView}&approvalMode=${approvalMode}`
//                     const response = await fetch(url)
//                     const data = await response.json()
//                     return data
//                 } catch (error) {
//                     console.log(error)
//                 }
//             },

//             async createShopPreste(appWsReviewsTokenView, store) {
//                 const response = await this.getPrestigeData(appWsReviewsTokenView, store)
//                 const anchor = document.querySelector('.other-pages-row [data-wsjs-prod-template="ws-review-shop"]')

//                 // estrutura html na ancora
//                 anchor.append(
//                     wsMain.tools.createElm({
//                         type: 'div',
//                         attrs: {
//                             id: 'clients-average-container',
//                         }
//                     }),
//                     wsMain.tools.createElm({
//                         type: 'div',
//                         attrs: {
//                             id: 'clients-review-filter',
//                         }
//                     }),
//                     wsMain.tools.createElm({
//                         type: 'div',
//                         attrs: {
//                             id: 'clients-review-container',
//                         }
//                     })
//                 )

//                 starRatingProductsPage.createClientAvarege(response)
//                 starRatingProductsPage.createReviews(response)
//                 starRatingProductsPage.createReportBtn(appWsReviewsTokenView, store)
//                 starRatingProductsPage.vrfyUser(appWsReviewsTokenView, store, '.likes', "like")
//                 starRatingProductsPage.vrfyUser(appWsReviewsTokenView, store, '.deslikes', "deslike")
//                 starRatingProductsPage.clientsReviewFilter(appWsReviewsTokenView, store)
//                 starRatingProductsPage.nextPage(appWsReviewsTokenView, store, response)
//             }
//         }

//         const appReviewBadges = {
//             async getData(storeId) {
//                 try {
//                     const url = `https://reviews-ws-script-app.webstore.net.br/store/stamp?store=${storeId}&approvalMode=${approvalMode}`
//                     const response = await fetch(url)
//                     const data = await response.json()

//                     return data
//                 } catch (error) {
//                     console.log(error)
//                 }
//             },
//             async createBadge(storeId) {
//                 const data = await this.getData(storeId)
//                 const li = wsMain.tools.createElm('li');

//                 li.setAttribute('id', data.name.trim().replace(/ /g, ''));

//                 let holder = wsMain.tools.createElm({
//                     type: 'a',
//                     attrs: {
//                         title: 'insígnias',
//                         class: 'badge-holder',
//                         target: '_blank',
//                         href: data.urlStamp || ''
//                     }
//                 });

//                 let img = wsMain.tools.createElm({
//                     type: 'img',
//                     lazyLoad: false,
//                     attrs: {
//                         src: data.urlStamp,
//                         alt: data.name
//                     }
//                 });

//                 holder.append(img);
//                 li.append(holder);
//                 document.querySelector('[data-wsjs-badges]').append(li);
//             }
//         }

//         // pega a etapa da loja, e ativa funcoes para cada etapa
//         async function productsRate() {
//             // appWsReviewsTokenViews e etapa
//             const etapa = document.querySelector('#HdEtapaLoja').value;


//             // objeto de funcoes com todas as etapas
//             // apenas chama as funcoes de cada etapa
//             const etapaFunctions = {
//                 HOME() {
//                     if (ws_reviews_options.list_reviews) {
//                         isReady('product-list', () => dynamicAnchor.prodAnchor())
//                         isReady('product-list', () => starRatingHome.getDataAndCreateStars(appWsReviewsTokenView, appWsReviewsStoreId))
//                         isReady('product-list', () => homeReviewSlider.createReviewSlider(appWsReviewsTokenView, appWsReviewsStoreId, etapa))
//                     }
//                     console.log(`home ok ${ws_reviews_options.list_reviews}`)
//                 },
//                 LISTAGEM() {
//                     if (ws_reviews_options.list_reviews) {
//                         isReady('product-list', () => dynamicAnchor.prodAnchor())
//                         isReady('product-list', () => starRatingHome.getDataAndCreateStars(appWsReviewsTokenView, appWsReviewsStoreId))
//                         isReady('product-list', () => homeReviewSlider.createReviewSlider(appWsReviewsTokenView, appWsReviewsStoreId, etapa))
//                     }
//                     console.log(`listagem ok ${ws_reviews_options.list_reviews}`)
//                 },
//                 PRODUTO() {
//                     if (ws_reviews_options.product_review) {
//                         isReady('pag-produto', () => dynamicAnchor.productPageAnchor())
//                         isReady('pag-produto', () => starRatingProductsPage.createContainersAndCallFunctions(appWsReviewsTokenView, appWsReviewsStoreId))
//                         isReady('product-list', () => homeReviewSlider.createReviewSlider(appWsReviewsTokenView, appWsReviewsStoreId, etapa))
//                     }
//                     console.log(`produto ok ${ws_reviews_options.product_review}`)
//                 },
//                 PAGINAS_INST() {
//                     isReady('product-list', () => shopPrestige.createShopPreste(appWsReviewsTokenView, appWsReviewsStoreId))
//                     isReady('product-list', () => homeReviewSlider.createReviewSlider(appWsReviewsTokenView, appWsReviewsStoreId, etapa))
//                 }
//             };
            
//             // verifica se a etapa e valida, e ativa a funcao de acordo com a etapa
//             etapaFunctions[etapa] != undefined ? await etapaFunctions[etapa]() : '';
//             // await appReviewBadges.createBadge(store)
//         }
        
//         try {
//             if (ws_reviews_options.store_reviews) {
//                 dynamicAnchor.bodyAncor()
//                 dynamicAnchor.storeReview()
//                 dynamicAnchor.iframeUrl()
//                 shopReviews.startIframe(appWsReviewsTokenView, appWsReviewsStoreId)
//                 isReady('info-lojas', () => institucionalAnchor())
//                 creatingLinearGradient();
//             }
//             console.log(`kickoff reviews ${JSON.stringify(ws_reviews_options)}`);
            
//             productsRate();
//         } catch (error) {
//             console.log(error);
//         }
//     }

//     try {
//         if (typeof dragBase == 'undefined') {
//             reviewsApp()
//         }
//     } catch (error) {
//         console.log(error)
//     }
// }, 1000) 